// extracted by mini-css-extract-plugin
export default {"table":"table_table__hiyWB","userinfoTable":"table_userinfoTable__PPYxJ","true":"table_true__bB3rl"};